import { CircularProgress } from "@mui/material";
import React, { FunctionComponent } from "react";

/**
 * A loader element, used to display a loading animation over a specific element.
 * Displays a circular progress element.
 * @see CircularProgress
 */
export const ElementLoader: FunctionComponent = () => {

    return (
        <div className="element-loader">
            <CircularProgress />
        </div>
    );
}